import Category from "../components/Category";
import BreadcrumbShop from "../components/BreadcrumbShop";

const Games = () => {
  return (
    <div>
      <BreadcrumbShop curPage={"Games"} />
      <Category talk={"Games"} />
    </div>
  );
};

export default Games;
